import React from "react";
import { labelUtils } from "../Util";
import "../style.scss";

const FormGroupWrapper = ({ arrEle, newElfromJSON, fieldEle, children }) => {
  return (
    <div
      className="form-group formarea-component"
      data-elementtype={arrEle.elementtype}
      id={arrEle.elementid}
      style={{
        display: labelUtils.getDisplayProperty(fieldEle),
        visibility: fieldEle?.["display-hidden"] === 1 ? "hidden" : "",
      }}
    >
      <div
        className="form-builder-label"
        style={labelUtils.getLabelStyle(fieldEle)}
      >
        {fieldEle?.["display-hidelabel"] !== 1 && (
          <>
            <label
              htmlFor={newElfromJSON}
              id={`${newElfromJSON}_label`}
              className="col-form-label mandatory-label label_placeholder"
            >
              {fieldEle?.["display-fieldlabel"]}&nbsp;
              {fieldEle?.["display-tooltip"] && (
                <span className="label-tooltip">
                  &nbsp;
                  <i
                    className="fa fa-question-circle text-muted"
                    data-toggle="tooltip"
                    data-placement="right"
                    title={fieldEle?.["display-tooltip"]}
                  ></i>
                </span>
              )}
            </label>
            {fieldEle?.["display-required"] === 1 && (
              <span style={{ color: "red", fontSize: "1.2rem" }}>
                &nbsp;&#42;
              </span>
            )}
          </>
        )}
      </div>
      {children}
    </div>
  );
};

export default FormGroupWrapper;
